import { BaseFolderSchema } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";
import { InventoryViewType } from "./inventory-view-type";

// Both purchase-orders and shipments use the same BaseViewWithId schema
const InventoryViewSchema = viewWithIdSchemas["purchase-orders"];

export const updateInventoryViewOrdering = {
  name: "updateInventoryViewOrdering" as const,
  input: z.object({
    viewType: InventoryViewType,
    views: z.array(InventoryViewSchema),
    folders: z.array(BaseFolderSchema),
  }),
  output: z.object({}),
};
